import { FC } from 'react';
import AllCollectionProvider from '@providers/collections/subProvider/AllCollection.provider';
import NewCollectionProvider from '@providers/collections/subProvider/NewCollection.provider';
import BottomMenu from '@components/collection/bottomMenu/BottomMenu';
import SurpriseMenuFloatButton from '@components/surpriseMenu/floatButton/SurpriseMenuFloatButton';
import PopularCollectionProvider from './subProvider/PopularCollection.provider';
import TrendAnimationProvider from './subProvider/TrendAnimation.provider';
const CollectionMainProvider: FC = () => {
  return <>
            <TrendAnimationProvider />
            <SurpriseMenuFloatButton />
            <NewCollectionProvider />
            <PopularCollectionProvider />
            <AllCollectionProvider />
            <BottomMenu />
        </>;
};
export default CollectionMainProvider;